var DownloadModule = (function () {
    function DownloadModule() {
    }
    return DownloadModule;
}());
export { DownloadModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download.module.ts.pre-build-optimizer.js